import type { UserPermission } from "@/lib/api";
import { useCurrentUserStore } from "@/stores/useCurrentUserStore";

/**
 * 権限欄に出す権限。課金の閲覧 (viewBilling) は課金 API が管理者以上に限られ、メンバーに付与しても
 * 見えるものが限られるため、権限としては残したまま欄には出さない。
 */
export const USER_PERMISSIONS: readonly {
	value: UserPermission;
	label: string;
	description: string;
}[] = [
	{
		value: "manageProjects",
		label: "プロジェクト管理",
		description: "プロジェクトの作成と、属するプロジェクトの編集・アーカイブ・メンバー管理",
	},
	{
		value: "manageAgents",
		label: "エージェント管理",
		description:
			"エージェントの作成・編集・削除・起動・停止・再起動 (シークレット・共有ボリュームを含む)",
	},
	{
		value: "manageSharedVolumes",
		label: "共有ボリューム管理",
		description: "共有ボリュームの作成・削除",
	},
	{ value: "runTraining", label: "学習", description: "学習ジョブの起動・中止" },
];

/** 管理者以上が暗黙に持つ全権限のうち、権限欄に出すもの。 */
export const ALL_USER_PERMISSIONS: readonly UserPermission[] = USER_PERMISSIONS.map((p) => p.value);

/** 現在のユーザーが権限を持つか (管理者は常に true)。サーバー側でも同じ判定を行う。 */
export function useHasPermission(permission: UserPermission): boolean {
	return useCurrentUserStore((s) => s.permissions.includes(permission));
}
